import DOMPurify from 'dompurify'
import { CalendarCheck2, Users } from 'lucide-react'
import Card from '../../../../components/common/Card'
import DefaultTable from '../../../../components/tables/DefaultTable/DefaultTable'
import { CompanyDetailType, useCompany } from '../../../../context/CompanyContext'
import { useNavigate } from 'react-router'

const Notes = () => {
    const navigate = useNavigate()
    const { detail } = useCompany()
    if (!detail) return null
    const notes = detail.notes

    const columns = [
        {
            key: 'id',
            label: '#'
        },
        {
            key: 'note_',
            label: 'Nota'
        }
    ]

    const formattedNotes = notes.map((item: CompanyDetailType['notes'][number]) => {
        return {
            ...item,
            note_: (
                <div className='space-y-1'>
                    <div className='space-y-1'>
                        <p className='font-bold text-sm'>{item.name}</p>
                        <div className='flex items-center gap-3 opacity-80'>
                            {item.users && item.users.length > 0 && (
                                <div className='flex items-center gap-1'>
                                    <Users className='w-4 h-4 text-brand-400' />
                                    <p className='text-sm opacity-80'>
                                        {item.users.map(
                                            (user: any, index: number) =>
                                                `${user.name}${index + 1 === item.users.length ? '' : ', '}`
                                        )}
                                    </p>
                                </div>
                            )}
                            {item.dateNotify && (
                                <div className='flex items-center gap-1'>
                                    <CalendarCheck2 className='w-4 h-4 text-error-400' />
                                    <p className='text-sm opacity-80'>{item.dateNotify}</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <p
                        className='text-sm line-clamp-3 opacity-80'
                        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.description || '') }}
                    />
                </div>
            )
        }
    })

    const handleClick = (row: any) => {
        if (!row.businessID) return
        navigate(`/negocio/${row.businessID}`)
    }

    const handleCreate = () => {
        console.log('handleCreate')
    }

    return (
        <Card>
            <h2 className='font-bold text-base mb-4'>Notas da empresa</h2>
            <DefaultTable columns={columns} rows={formattedNotes} rowsPerPage={20} handleClick={handleClick} />
        </Card>
    )
}

export default Notes
